<div class="list-item menu-item">
  <div class="row menu-item">
    <div class="col-10">
      <a
        data-toggle="collapse"
        type="button"
        class="btn-panel panel-heading-drop {{
          item.selected ? '' : 'collapsed'
        }}"
      >
        <div (click)="select(item)">
          {{ item.description }}
        </div>
      </a>
    </div>
    <div class="col-2 list-item-icon" (click)="item.selected = !item.selected">
      <div *ngIf="item.children.length; else quantityBlock">
        <a class="panel-heading collapsed"></a>
      </div>
      <ng-template #quantityBlock>
        <span class="badge badge-secondary">{{ item.quantity }}</span>
      </ng-template>
    </div>
  </div>
  <div
    *ngIf="item.children.length > 0"
    id="box{{ item.id }}"
    class="pl-3 list-group list-group-flush panel-collapse collapse {{
      item.selected ? 'show' : ''
    }}"
  >
    <div class="dropdown-box">
      <app-catalog-menu-click
        #submenu
        [selected]="i.selected"
        (onSelect)="onChildrenSelected($event)"
        *ngFor="let i of item.children"
        [item]="i"
        [parent]="parent + ' > ' + item.description"
        (breadCrumb)="saveBc($event)"
      ></app-catalog-menu-click>
    </div>
  </div>
</div>
